// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","container":"styles_container__xK58k","fontPrimary":"styles_fontPrimary__nMJXk"};